<template>
    <!--
    https://aosmithv2.iwxapi.com/archives/dossier?account_id=a83c004c-7d1e-acd8-0000-06431d8da45b
      -->
    <div class="content dossier">
        <div class="user_wrap">
            <div class="user_info flex aic">
                <img src="~@/assets/images/user/housev2/head_dome.png" class="user_head"></img>
                <div class="info_box">
                    <div class="info_top flex aic">
                        <p>{{ objArchivesInfo.name }}</p>
                        <p>{{ objArchivesInfo.createdon }}</p>
                    </div>
                    <div class="info_bottom flex">
                        <p>{{ objArchivesInfo.new_telephone || '--' }}</p>
                        <p>{{ objArchivesInfo.new_sparephone || '--' }}</p>
                    </div>
                </div>
                <!--  <div class="edit_btn flex aic juc">
                        <img src="~@/assets/images/archives/dossier/edit_icon.png" alt="">编辑
                 </div>-->
            </div>
            <div :class="{'dossier_info':true,'undold_info':isUnfoldInfo}">
                <div class="item flex">
                    <p>信息来源：</p>
                    <p>{{ objArchivesInfo.new_source || '--' }}</p>
                    <p>签单手：</p>
                    <p>{{ objArchivesInfo.new_salesperson_id || '--' }}</p>
                </div>
                <div class="item flex">
                    <p>负责人：</p>
                    <p>{{ objArchivesInfo.owner_name || '--' }}</p>
                </div>
                 <div class="item flex">
                    <p>设计公司：</p>
                    <p>{{ objArchivesInfo.new_homedesignercompany || '--' }}</p>
                </div>
                <div class="item flex">
                    <p>设计师：</p>
                    <p>{{ objArchivesInfo.new_homedesignername || '--' }}</p>
                    <p>设计师电话：</p>
                    <p>{{ objArchivesInfo.new_homedesignerphone || '--' }}</p>
                </div>
                <div class="item flex">
                    <p>小a信息：</p>
                    <p>{{ objArchivesInfo.new_aname || '--' }}</p>
                    <p>小a电话：</p>
                    <p>{{ objArchivesInfo.new_aphone || '--' }}</p>
                </div>
            </div>
            <div :class="{'unfold_icon':true,'pack':!isUnfoldInfo}">
                <img src="~@/assets/images/archives/dossier/unfold.png" alt="" @click="touchUnfold">
            </div>
        </div>
        <div class="project_wrap">
            <div class="project_item flex fnw">
                <div v-for="(item,index) in objArchivesInfo.contract"
                     :class="{'item':true, 'item_select':nProjectIndex == index}" @click="touchProject(index)">
                    项目 {{ hadnleNum(item.number) }}
                </div>
            </div>
            <!--  <div class="add_btn">
                            <img src="~@/assets/images/archives/dossier/add_icon.png" alt="">
              </div>-->
        </div>
        <div class="info_wrap">
            <div class="title">
                <!-- new_approvalstatus: 3-->
                <!-- ,'blue':true,'orange':true,'red':true-->
                <span v-if="objProjectInfo.new_approvalstatus_text" :class="[objProjectInfo.icon]">{{
                        objProjectInfo.new_approvalstatus_text
                    }}</span>
                {{ objProjectInfo.new_name ? objProjectInfo.new_name : '需完善信息' }}
                <span v-if="objProjectInfo.check_change == 1" class="change_status">(变更已审核)</span>
                <span v-if="objProjectInfo.check_change == 2" class="change_status">(变更中)</span>
            </div>
            <div class="info_box">
                <div class="info_item flex">
                    <p>项目类型：</p>
                    <p>{{ objProjectInfo.new_projecttype ? objProjectInfo.new_projecttype : '暂无' }}</p>
                </div>
                <div class="info_item flex">
                    <p>成交金额：</p>
                    <p>{{ objProjectInfo.new_totalamount ? objProjectInfo.new_totalamount + '元' : '暂无' }}</p>
                </div>
            </div>
            <div v-if="objProjectInfo.workday" class="team_box">
                <div class="team_title flex aic">
                    <img src="~@/assets/images/archives/dossier/schedule_icon.png" alt=""/>项目施工进度
                </div>
                <div class="team_info" style="margin-bottom:15px">
                    <div class="team_item2 flex">
                        <p>开始时间：</p>
                        <p>{{ objProjectInfo.workday.start_date || '--' }}</p>
                    </div>
                    <div class="team_item2 flex">
                        <p>完成时间：</p>
                        <p>{{ objProjectInfo.workday.end_date || '--' }}</p>
                    </div>
                </div>
                <div class="day_num">
                    {{ objProjectInfo.workday.text }}：<span style="color:#0d53fc;margin-right: 4px;">{{
                        objProjectInfo.workday.total
                    }}</span>天
                </div>
            </div>
            <div class="team_box">
                <div class="team_title flex aic">
                    <img src="~@/assets/images/archives/dossier/team_icon.png" alt=""/>项目团队
                </div>
                <div class="team_info flex fw">
                    <div v-for="(item,key) in objProjectInfo.server" class="team_item flex">
                        <p>{{ item.job }}：</p>
                        <p>{{ item.name || '--' }}</p>
                    </div>
                </div>
            </div>
            <div class="assess_box flex aic" @click="touchScoreInfo">
                <p>当前客户评价：</p>
                <template v-if="score != -1">
                    <van-rate v-model="score" :size="16" allow-half readonly color="#FCC70D"
                              void-icon="star"
                              void-color="#eee"/>
                    <p>详情</p>
                    <img src="~@/assets/images/archives/dossier/arrow_icon.png" alt="">
                </template>
                <template v-else>
                    <p>暂无评价</p>
                </template>
            </div>
            <div v-if="false" class="btns_box flex jusb">
                <button>体验邀请</button>
                <button>跟进记录</button>
                <button>转派</button>
                <button>丢单</button>
            </div>
        </div>
        <div class="nav_box">
            <!--导航栏-->
            <navbar :index="nNavIndex" :accountId="accountId" :projectId="objProjectInfo.new_project_id"
                    :contractId="objProjectInfo.new_contractid"
                    @touchNav="touchNav"></navbar>
        </div>
        <div class="content_wrap">
            <transition name="arc-dossier-transform" mode="out-in">
                <router-view></router-view>
            </transition>
        </div>

        <img class="back_icon" @click="touchBack" src="~@/assets/images/archives/dossier/back_icon.png"/>

        <div class="bottom_btns flex aic">
            <button v-if="objProjectInfo.new_approvalstatus == 3 && objProjectInfo.new_contracttype == 1"
                    @click="touchShare('member')">分享交付书
            </button>
            <button v-if="isShowShareDesigner"
                    @click="touchShare('designer')">分享设计师
            </button>
            <button @click="toPoster">生成喜报</button>
        </div>
        <div v-show="showShare" class="guide" @click.stop="showGuide">
            <img class="share_hand" src="~@/assets/images/user/housev2/share_hand.png"
                 alt="手"/>
            <div class="share_hint">
                <img class="share_icon" src="~@/assets/images/user/housev2/share_icon.png" alt="分享"/>
                <p>点击 “...” 去分享</p>
            </div>
        </div>
    </div>
</template>

<script>
import navbar from './components/nav_bar/index.vue';
import {getDataviewUserInfo, getArchivesInfo} from "@/js/archives/dossier.js";
import {ImagePreview} from "vant";
import {getWxSingleConfig} from "@/js/wx";

export default {
    name: "Dossier",
    data() {
        return {
            nNavIndex: 0,
            accountId: '',
            contractId: '',
            nProjectIndex: 0,
            objArchivesInfo: {},
            objProjectInfo: {},
            isUnfoldInfo: true,
            showShare: false,
            systemuserid: '',
            isShowShareDesigner: false
        }
    },
    components: {
        navbar
    },
    mounted() {
        this.accountId = this.$route.query.account_id;
        this.contractId = this.$route.query.contract_id;
        $init(() => {
            this.getArchivesInfoFun()
            this.getDataviewUserInfo()
            this.$store.commit("loadSkeleton", {bool: true}); // 页面loading开启
        })
    },
    computed: {
        score() {
            if (this.objProjectInfo.discuss) {
                let isLack = this.objProjectInfo.discuss.score >= 0 || false;
                // alert(JSON.stringify(this.objProjectInfo.discuss) + '-' + isLack);
                return Number(isLack ? this.objProjectInfo.discuss.score : -1);
            } else {
                return -1;
            }
        }
    },
    methods: {
        // 生成喜报
        toPoster() {
            let new_code = this.objArchivesInfo.contract[this.nProjectIndex].new_code
            if (!new_code) {
                this.$toast('合同号为空~')
                return
            }
            this.$router.push({
                path: `/other/poster/sales`,
                query: {new_code}
            })
        },
        hadnleNum(num) {
            return num.toLocaleString('zh-u-nu-hanidec');
        },
        getDataviewUserInfo() {
            getDataviewUserInfo().then((res) => {
                let data = res.data.data.result;
                if (data.systemuserid) {
                    this.systemuserid = data.systemuserid;
                } else {
                    if (process.env.VUE_APP_FLAG == "production") {
                        this.systemuserid = data.systemuserid;
                    } else {
                        //测试环境如果没有systemuserid，给个默认值
                        this.systemuserid = '36db6975-27d3-ea11-b0ba-0017fa026433';
                    }
                }
            })
        },
        getArchivesInfoFun() {
            getArchivesInfo({
                account_id: this.accountId,
                contract_id: this.contractId
            }).then((res) => {
                console.log('objArchivesInfo', res.data.data.result)
                this.objArchivesInfo = res.data.data.result;
                this.touchProject(0)
            })
        },
        touchProject(index) {
            this.nProjectIndex = index;
            this.objProjectInfo = this.objArchivesInfo.contract[index] || {};
            this.nNavIndex = 0;
            if (this.objProjectInfo.server && this.objProjectInfo.server.length > 0) {
                // 项目信息来源为 设计师/家装公司 且 合同有设计师手机号才展示分享设计师按钮
                this.isShowShareDesigner = this.objArchivesInfo.new_source == '设计师/家装公司' && (this.objProjectInfo.server.findIndex(it => it.job == "设计师" && it.phone))
            }

            this.$router.replace({
                path: `/archives/dossier/log?account_id=${this.accountId}&project_id=${this.objProjectInfo.new_project_id || ''}&contract_id=${this.objProjectInfo.new_contractid || ''}`,
            });
        },
        touchNav(e) {
            this.nNavIndex = e.index;
        },
        touchUnfold() {
            this.isUnfoldInfo = !this.isUnfoldInfo;
        },
        touchBack() {
            this.$router.back();
        },
        touchScoreInfo() {
            if (this.score != -1) {
                this.$router.push({
                    path: `/archives/evaluate/index`,
                    query: {project_uuid: this.objProjectInfo.new_project_id}
                })
            }
        },
        showGuide() {
            this.showShare = false;
        },
        touchShare(type) {
            if (this.systemuserid) {
                let path = '';
                let query = {};
                if (type == 'member') {
                    path = '/member/v2/index/index';
                    query = {
                        sampleroom: 2,
                        accountid: this.objArchivesInfo.accountid,
                        contractid: this.objProjectInfo.new_contractid,
                        systemuserid: this.systemuserid,
                        form: 'dossier'
                    }
                } else {
                    path = '/designer/project/index';
                    query = {
                        sampleroom: 2,
                        new_srv_projectmgnid: this.objProjectInfo.new_project_id,
                        new_account_id: this.objArchivesInfo.accountid,
                        new_contract_id: this.objProjectInfo.new_contractid,
                        new_name: this.objProjectInfo.new_name,
                        form: 'dossier'
                    }
                }
                this.$router.push({
                    path: path,
                    query: query
                })
            } else {
                this.$toast('未查询到您的艾暖通账号')
            }
            // this.setShare();
        },
        setShare() {
            let data = {
                share_friend_title: `${this.objProjectInfo.new_name ? this.objProjectInfo.new_name : '用户'}-项目交付档案`,
                share_friend_desc: '施工全流程在线交付 有源可溯',
                share_img_url: 'https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/share/member_share_icon_v2.jpg',
                share_link: `${window.location.protocol}//${window.location.host}/member/v2/index/index?id=${this.objProjectInfo.new_project_id}&shareUserId=${this.$storage.getStorage('user_id')}`,
            }
            getWxSingleConfig(data).then((res) => {
                this.showShare = true;
            })
        },
    }

}
</script>
<style lang="scss" scoped>
.flex {
    display: flex;
}

.aic {
    align-items: center;
}

.aie {
    align-items: flex-end;
}

.juc {
    justify-content: center;
}

.jue {
    justify-content: flex-end;
}

.jusb {
    justify-content: space-between;
}

.fw {
    flex-wrap: wrap;
}

.fnw {
    flex-wrap: nowrap;
}

.content {
    width: 100vw;
    min-height: 100vh;
    background: #F9F9FB;
}

.user_wrap {
    width: 100vw;
    background: #F3F6FF;
    padding: 32px 32px 16px;

    .user_info {
        margin-bottom: 64px;
        position: relative;

        .user_head {
            width: 96px;
            height: 96px;
            border-radius: 50%;
        }

        .info_box {
            margin-left: 32px;
            margin-right: auto;
        }

        .info_top {
            p:nth-child(1) {
                font-size: 36px;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: bold;
                color: $blackText;
                line-height: 42px;
            }

            p:nth-child(2) {
                min-width: 200px;
                font-size: 24px;
                font-family: PingFang SC-Regular, PingFang SC;
                color: #A8A9AF;
                line-height: 28px;
                margin-left: 16px;
                margin-bottom: 4px;
            }
        }

        .info_bottom {
            margin-top: 12px;

            p {
                font-size: 24px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #555555;
                line-height: 28px;
                padding: 0 16px;
                border-left: 1px solid #DBDDE6;
            }

            p:nth-child(1) {
                padding-left: 0;
                border-left: none;
            }
        }

        .edit_btn {
            width: 128px;
            height: 48px;
            border-radius: 8px 8px 8px 8px;
            border: 2px solid #0D53FC;
            text-align: center;
            font-size: 24px;
            font-family: PingFang SC-Regular, PingFang SC;
            color: #0D53FC;
            line-height: 28px;

            img {
                width: 32px;
                height: 32px;
                display: block;
                margin-right: 8px;
            }
        }

        .share_btn {
            padding: 10px 16px;
            border-radius: 8px 8px 8px 8px;
            border: 2px solid #0D53FC;
            text-align: center;
            font-size: 24px;
            font-family: PingFang SC-Regular, PingFang SC;
            color: #0D53FC;
            line-height: 28px;
            position: absolute;
            right: 0;
            bottom: -24px;
        }
    }

    .dossier_info {
        height: 217px;
        overflow: hidden;
        transition: height 0.5s;
        position: relative;

        .item {
            margin-bottom: 16px;

            p {
                height: 28px;
                line-height: 28px;
            }

            p:nth-child(2n - 1) {
                width: 150px;
                font-size: 24px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #A3A3A3;
            }

            p:nth-child(2) {
                margin-right: auto;
            }

            p:nth-child(4) {
                width: 146px;
            }
        }

    }

    .undold_info {
        height: 44px;
    }

    .unfold_icon {
        width: 100%;

        img {
            display: block;
            width: 26px;
            height: 26px;
            margin: 0 auto;
            transform: rotate(0deg);
            transition: transform 0.5s;
        }
    }

    .pack {
        img {
            transform: rotate(180deg);
        }
    }

}


.info_wrap {
    padding: 32px 0;
    background: #FFFFFF;

    .title {
        font-size: 36px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: bold;
        color: #333333;
        line-height: 42px;
        margin-bottom: 32px;
        padding: 0 32px;

        span {
            padding: 3px 28px;
            box-sizing: border-box;
            position: relative;
            top: -4px;
            border-radius: 20px;
            text-align: center;
            font-size: 24px;
            line-height: 40px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: normal;
            color: #FFFFFF;
            background: #24AE71;
            margin-right: 12px;
            display: inline-block;
        }

        .green {
            background: #24AE71;
        }

        .blue {
            background: #45ADD9;
        }

        .orange {
            background: #EE9859;
        }

        .red {
            background: #E85858;
        }

        .gray {
            background: #939393;
        }

        .change_status {
            background: transparent;
            font-size: 36px;
            color: red;
            padding: 0;
            margin: 0;
        }
    }

    .info_box {
        margin-bottom: 12px;
        padding: 0 32px;

        .info_item {
            padding-bottom: 20px;

            p {
                font-size: 24px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #A3A3A3;
                line-height: 28px;
            }

            p:nth-child(2) {
                color: #3D3C4F;
            }
        }
    }

    .team_box {
        padding: 0 32px;
        position: relative;

        .team_title {
            margin-bottom: 20px;

            img {
                width: 32px;
                height: 32px;
                display: block;
                margin-right: 16px;
            }
        }

        .team_info {
            width: 100%;
            margin-bottom: 12px;

            .team_item {
                margin-bottom: 20px;

                p {
                    font-size: 24px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #A3A3A3;
                    line-height: 28px;
                }

                p:nth-child(1) {
                    width: 120px;
                }

                p:nth-child(2) {
                    color: #3D3C4F;
                }
            }

            .team_item:nth-child(3n) {
                width: 26%;
                min-width: 26%;
                justify-content: flex-end;

                p:nth-child(1) {
                    width: 100px;
                }
            }

            .team_item:nth-child(3n - 1) {
                width: 37%;
                min-width: 37%;
            }

            .team_item:nth-child(3n - 2) {
                width: 35%;
                min-width: 37%;
            }

        }

        .team_item2 {
            width: calc(100% - 280px);
            margin-bottom: 20px;

            p {
                font-size: 24px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #A3A3A3;
                line-height: 28px;
            }

            p:nth-child(1) {
                width: 120px;
            }

            p:nth-child(2) {
                color: #3D3C4F;
            }
        }

        .day_num {
            position: absolute;
            right: 32px;
            bottom: 0px;

            padding: 15px 10px;
            border-radius: 12px;
            border: 1px solid #0d53fc;
        }
    }

    .assess_box {
        width: 686px;
        height: 80px;
        background: rgba(13, 83, 252, 0.05);
        border-radius: 16px;
        margin: 0 auto;
        padding: 0 32px;

        p {

            font-size: 24px;
            font-family: PingFang SC-Regular, PingFang SC;
            line-height: 28px;
        }

        p:nth-child(1) {
            font-weight: bold;
            color: $blackText;
            margin-right: 16px;
        }

        p:nth-child(3) {
            font-weight: 400;
            color: #A3A3A3;
            margin-left: auto;
        }

        img {
            width: 24px;
            height: 24px;
            display: block;
            margin-left: 16px;
        }
    }

    .btns_box {
        margin: 0 32px 32px;
        padding-bottom: 48px;
        border-bottom: 2px solid #F5F5F5;

        button {
            width: 150px;
            height: 64px;
            border-radius: 16px 16px 16px 16px;
            border: 2px solid #0D53FC;
            background: #FFFFFF;
            text-align: center;
            font-size: 24px;
            font-family: PingFang SC-Regular, PingFang SC;
            color: #0D53FC;
            line-height: 64px;
        }
    }
}

.project_wrap {
    width: 100%;
    height: 80px;
    margin-top: 20px;
    background: #FFFFFF;
    box-shadow: 0px -4px 4px 0px rgba(0, 0, 0, 0.01);
    position: relative;

    .project_item {
        width: calc(100% - 80px);
        overflow-x: scroll;
    }

    .item {
        min-width: 168px;
        height: 80px;
        line-height: 80px;
        text-align: center;
        font-size: 24px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: bold;
        color: #A3A3A3;
        border-right: 2px solid;
        border-right-color: #F2F2F2;
        text-align: center;
        background-color: #FFFFFF;
        transition: background-color 0.2s, border-right-color 0.2s;
    }

    .item_select {
        color: #FFFFFF;
        background-color: #0D53FC;
        border-right-color: #0D53FC;
    }

    .add_btn {
        width: 80px;
        height: 80px;
        background: #FFFFFF;
        box-shadow: -4px 0px 8px 0px rgba(0, 0, 0, 0.0500);

        position: absolute;
        top: 0;
        right: 0;

        img {
            width: 48px;
            height: 48px;
            display: block;
            margin: 16px auto;
        }
    }
}

.project_wrap::after {
    content: "";
    width: 100%;
    height: 2px;
    background: #F2F2F2;
    position: absolute;
    bottom: 0;
    left: 0;
}

content_wrap {
    position: sticky;
    top: 80px;
    z-index: 99;
}

.nav_box {
    width: 100%;
    background: #FFFFFF;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    padding: 32px 0 10px;
    position: sticky;
    top: 0;
    left: 0;
    z-index: 99;
}

.back_icon {
    position: fixed;
    left: 32px;
    bottom: calc(env(safe-area-inset-bottom) + 150px);
    z-index: 999;
    width: 100px;
    height: 100px;
}

.bottom_btns {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 99;
    background: #FFFFFF;
    width: 100%;
    height: calc(112px + env(safe-area-inset-bottom));
    padding: 0 32px env(safe-area-inset-bottom);
    box-shadow: 0px -4px 8px 0px rgba(0, 0, 0, 0.03);

    button {
        width: 160px;
        height: 64px;
        background: #0D53FC;
        border-radius: 16px;
        font-size: 24px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 64px;
        margin-right: 20px;
        text-align: center;
    }
}

.guide {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    z-index: 99999;
    left: 0;
    background: rgba(0, 0, 0, 0.6);

    .share_hand {
        width: 90px;
        height: 121px;
        margin: 25px 10px 0 auto;
        display: block;
    }

    .share_hint {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        p {
            font-size: 43px;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #ffffff;
            line-height: 48px;
            text-align: center;
        }
    }

    .share_icon {
        width: 108px;
        height: 108px;
        display: block;
        margin: 0 auto 65px;
    }
}


</style>
